import loggerGenerator from '@travel/logger';
import { setCommonError } from 'store/commonError/slice';

import type { Store } from 'react-redux';
import { EXCEPTION_PATH_LIST } from 'constants/api';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

type ResponseInterceptorOptions = {
  response: Response;
  resolve: (value: unknown) => void;
  reject: (reason?: unknown) => void;
};

const isExceptionPath = (status: number, url: string): boolean =>
  (EXCEPTION_PATH_LIST[status] ?? []).some((pattern) => {
    if (pattern instanceof RegExp) {
      return pattern.test(url);
    }

    return url.includes(pattern as string);
  });

const responseInterceptor =
  (store: Store) =>
  ({ response }: ResponseInterceptorOptions) => {
    // additional handler for maintenance mode
    if (response.status === 503 && !isExceptionPath(503, response.url)) {
      store.dispatch(
        setCommonError({
          message: 'Service is unavailable',
          httpStatusCode: response.status,
          type: 'redirect',
        }),
      );
      logger.error(`503 error`, response.url, response.status);
      noticeError(`503 Error`, {
        url: response.url,
        res: response,
      });
    } else if (response.status === 408 && !isExceptionPath(408, response.url)) {
      store.dispatch(
        setCommonError({
          message: 'Network error',
          httpStatusCode: response.status,
          type: 'redirect',
        }),
      );
      logger.error(`408 Network error`, response.url, response.status);
      noticeError(`408 Network Error`, {
        url: response.url,
        res: response,
      });
    }
  };

export default responseInterceptor;
